import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_SOUND = "GET_LIST_SOUND";
export const GET_LIST_SOUND_ERROR = "GET_LIST_SOUND_ERROR";
export const GET_LIST_SOUND_SUCCESS = "GET_LIST_SOUND_SUCCESS";

export const COUNT_LIST_SOUND = "COUNT_LIST_SOUND";
export const COUNT_LIST_SOUND_ERROR = "COUNT_LIST_SOUND_ERROR";
export const COUNT_LIST_SOUND_SUCCESS = "COUNT_LIST_SOUND_SUCCESS";

export const DELETE_SOUND = "DELETE_SOUND";
export const DELETE_SOUND_ERROR = "DELETE_SOUND_ERROR";
export const DELETE_SOUND_SUCCESS = "DELETE_SOUND_SUCCESS";

export const EDIT_SOUND = "EDIT_SOUND";
export const EDIT_SOUND_SUCCESS = "EDIT_SOUND_SUCCESS";
export const EDIT_SOUND_ERROR = "EDIT_SOUND_ERROR";

export const ADD_SOUND = "ADD_SOUND";
export const ADD_SOUND_SUCCESS = "ADD_SOUND_SUCCESS";
export const ADD_SOUND_ERROR = "ADD_SOUND_ERROR";

export const UPLOAD_SOUND = "UPLOAD_SOUND";
export const UPLOAD_SOUND_SUCCESS = "UPLOAD_SOUND_SUCCESS";
export const UPLOAD_SOUND_ERROR = "UPLOAD_SOUND_ERROR";
/**
 * Reducer
 */

const initialState = {
  sounds: [],
  sound: {},
  error: false,
  count: 0,
  loading: false,
  file: null,
};

export const soundReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_SOUND:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_SOUND_SUCCESS:
      return {
        ...state,
        loading: false,
        sounds: action.payload,
      };
    case GET_LIST_SOUND_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count list
    case COUNT_LIST_SOUND:
      return {
        ...state,
        loading: true,
      };
    case COUNT_LIST_SOUND_SUCCESS:
      return {
        ...state,
        loading: false,
        count: action.payload,
      };
    case COUNT_LIST_SOUND_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //delete list
    case DELETE_SOUND:
      return {
        ...state,
      };
    case DELETE_SOUND_SUCCESS:
      return {
        ...state,
        sound: action.payload,
      };
    case DELETE_SOUND_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //EDIT
    case EDIT_SOUND:
      return {
        ...state,
      };
    case EDIT_SOUND_SUCCESS:
      return {
        ...state,
        sound: action.payload,
      };
    case EDIT_SOUND_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add
    case ADD_SOUND:
      return {
        ...state,
      };
    case ADD_SOUND_SUCCESS:
      return {
        ...state,
        sound: action.payload,
      };
    case ADD_SOUND_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //upload
    case UPLOAD_SOUND:
      return {
        ...state,
      };
    case UPLOAD_SOUND_SUCCESS:
      return {
        ...state,
        file: action.payload,
      };
    case UPLOAD_SOUND_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListSound = (order, limit, skip, where) => ({
  type: GET_LIST_SOUND,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListSound = (where) => ({
  type: COUNT_LIST_SOUND,
  data: {
    where,
  },
});

export const deleteSound = (id) => ({
  type: DELETE_SOUND,
  data: {
    id,
  },
});

export const editSound = (id, name, fileName, note) => ({
  type: EDIT_SOUND,
  data: {
    id,
    name,
    fileName,
    note,
  },
});

export const addSound = (name, fileName, note) => ({
  type: ADD_SOUND,
  data: {
    name,
    fileName,
    note,
  },
});

export const uploadSound = (file) => ({
  type: UPLOAD_SOUND,
  data: {
    file,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListSound,
      deleteSound,
      editSound,
      addSound,
      countListSound,
      uploadSound,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListSoundApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/cloud-pbx/sound", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListSoundApi = (where) => {
  return apiCaller.getLogs("/cloud-pbx/sound/count", { ...where });
};

const deleteSoundApi = (id) => {
  return apiCaller.del(`/cloud-pbx/sound/${id}`);
};

const addSoundApi = (name, fileName, note) => {
  return apiCaller.post("/cloud-pbx/sound", { name, fileName, note });
};

const uploadSoundApi = (file) => {
  return apiCaller.postUpload("/media-mgt/container/ivrs/upload", file);
};

const editSoundApi = (id, name, fileName, note) => {
  return apiCaller.put(`/cloud-pbx/sound/${id}`, { name, fileName, note });
};

/**
 * sagas
 */

export const getListSoundFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_SOUND);
    try {
      const res = yield call(
        getListSoundApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_SOUND_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_SOUND_ERROR, error });
    }
  }
};

export const deleteSoundFlow = function* () {
  while (true) {
    const action = yield take(DELETE_SOUND);
    try {
      const res = yield call(deleteSoundApi, action.data.id);
      yield put({ type: DELETE_SOUND_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: DELETE_SOUND_ERROR, error });
    }
  }
};
export const editSoundFlow = function* () {
  while (true) {
    const action = yield take(EDIT_SOUND);
    try {
      const res = yield call(
        editSoundApi,
        action.data.id,
        action.data.name,
        action.data.fileName,
        action.data.note
      );
      yield put({ type: EDIT_SOUND_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_SOUND_ERROR, error });
    }
  }
};
export const addSoundFlow = function* () {
  while (true) {
    const action = yield take(ADD_SOUND);
    try {
      const res = yield call(
        addSoundApi,
        action.data.name,
        action.data.fileName,
        action.data.note
      );
      yield put({ type: ADD_SOUND_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: ADD_SOUND_ERROR, error });
    }
  }
};

export const countSoundFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_SOUND);
    try {
      const res = yield call(countListSoundApi, action.data.where);
      yield put({ type: COUNT_LIST_SOUND_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: COUNT_LIST_SOUND_ERROR, error });
    }
  }
};

export const uploadSoundFlow = function* () {
  while (true) {
    const action = yield take(UPLOAD_SOUND);
    try {
      const res = yield call(uploadSoundApi, action.data.file);
      yield put({ type: UPLOAD_SOUND_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: UPLOAD_SOUND_ERROR, error });
    }
  }
};
